import { appGetState, appNextState, appUpdateState } from "store";
import { IToastOptions } from "components/common/ui/toast/Toast";
import { generateTimestampID, generateUEID } from "utils/common";
import React from "react";
import { catchRequestErrorMessage } from "utils/catchErrorUtils";

const comment = (m: string) => `LayoutService::${m}`;

class LayoutService {
  private appGetState = appGetState;
  private appNextState = appNextState;
  private appUpdateState = appUpdateState;

  /**
   */
  public expandSidebarToggle = (isExpanded: boolean) => {
    this.appUpdateState(
      (s) => (s.layout.isExpanded = isExpanded),
      comment("expandSidebarToggle")
    );
  };

  public expandMobileSidebarToggle = (isMobileOpened: boolean) => {
    this.appUpdateState(
      (s) => (s.layout.isMobileOpened = isMobileOpened),
      comment("expandMobileSidebarToggle")
    );
  };

  public setDesktopLayout = (setDesktopLayout: boolean) => {
    this.appUpdateState(
      (s) => (s.layout.isDesktop = setDesktopLayout),
      comment("setDesktopLayout")
    );
  };

  /**
   */
  public addToast = (
    content: string | React.ReactNode,
    { id, timeStampId = true, ...options }: IToastOptions = {}
  ) => {
    const genId = id
      ? timeStampId
        ? generateTimestampID(id)
        : id
      : generateUEID();
    const toasts = this.appGetState().layout.toasts;

    //exit if toast exists
    if (toasts.filter((t) => t.id === id).length) {
      return;
    }
    this.appUpdateState(
      (s) =>
        (s.layout.toasts = [...toasts, { id: genId, content, ...options }]),
      comment("toastAdded")
    );
  };

  public removeToast = (id: string) => {
    const oldToasts = this.appGetState().layout.toasts;
    if (!oldToasts.filter((t) => t.id === id).length) {
      return;
    }
    this.appUpdateState(
      (s) => (s.layout.toasts = oldToasts.filter((t) => t.id !== id)),
      comment("toastRemoved")
    );
  };

  public error = (
    e: RequestError | unknown,
    defaultMessage = "Error",
    theme = "danger" as ThemeVariants,
    options?: IToastOptions
  ) => {
    this.addToast(catchRequestErrorMessage(e, defaultMessage), {
      autoDismiss: false,
      ...options,
      theme,
    });
  };

  public setIsLoading = (isLoading: boolean): void => {
    this.appUpdateState(
      (s) => (s.layout.isLoading = isLoading),
      comment("setIsLoading")
    );
  };
}

const layoutService = new LayoutService();
export { layoutService };
